import { gql } from '@apollo/client';

export const PRODUCT_EXTERNAL_SEARCH = gql`
  query ProductExternalSearch($query: ProductExternalSearchQueryInput!) {
    productExternalSearch(query: $query) {
      offers {
        ...ProductExternalOfferSummary
      }
    }
  }
`;

export const PRODUCT_EXTERNAL_BY_ID = gql`
  query ProductExternalById($productId: String!) {
    productExternalById(productId: $productId) {
      ...ProductExternalSummary
    }
  }
`;

export const GET_PRODUCT_CATALOG_SEARCH_RESULTS = gql`
  query ProductCatalogSearchResults($query: ProductCatalogSearchQueryInput!, $limit: Int!) {
    productCatalogSearchResults(query: $query) {
      allResults(limit: $limit) {
        catalogItem {
          ...ProductCatalogItemSummary
          ...ProductCatalogItemDimensions
        }
      }
    }
  }
`;

export const CATALOG_CATEGORY_CHILDREN = gql`
  query CatalogCategoryChildren($type: CatalogTreeRootInput) {
    productCatalogCategoryTreeRoot(type: $type) {
      children {
        ...CatalogCategoryChildrenSummary
        children {
          ...CatalogCategoryChildrenSummary
        }
      }
    }
  }
`;

export const SEOREDIRECT_BY_LOCATOR = gql`
  query SeoRedirectByLocator($url: String!) {
    productCatalogCategoryByLocator(url: $url) {
      id
      seoRedirectPath
    }
  }
`;

export const CATALOG_DEPARTMENT_LINEAGE = gql`
  fragment CoreCatalogCategoryFields on ProductCatalogCategory {
    id
    title
    heroText
    publicUrlPath
    isFeatured
    thumbnail {
      url
    }
    showcase {
      title
      image {
        url
      }
    }
  }

  fragment CoreCatalogCategoryFieldsWithChildren on ProductCatalogCategory {
    ...CoreCatalogCategoryFields

    children {
      ...CoreCatalogCategoryFields

      children {
        ...CoreCatalogCategoryFields

        children {
          ...CoreCatalogCategoryFields
        }
      }
    }
  }

  query ProductCatalogByLocator($url: String!) {
    productCatalogCategoryByLocator(url: $url) {
      ...CoreCatalogCategoryFieldsWithChildren
    }
  }

  query ProductCatalogDepartments($storefront: CatalogStorefront, $types: [CatalogTreeRootInput!]!) {
    productCatalogCategoryTreeRoot(types: $types, storefront: $storefront) {
      ...CoreCatalogCategoryFieldsWithChildren
    }
  }
`;
